import makeStyles from '@mui/styles/makeStyles'
import { instrumentStyles } from '../utils/instrumentIconStyles'

const useStyles: any = makeStyles(theme => instrumentStyles(theme))

export const useInstrumentIconType = (securityType: string | null) => useStyles()[`iconType${securityType || 'E'}`]
